import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
/* eslint-disable */

import useStore from 'webmd-cms-store/src/store';

export default{
    created() { 
       this.store = useStore(this.$pinia);
    },

	data() {
		return {
			imageServerUrl: this.getImageServerUrl(),
		}
	},
	methods: {
        getReviewDate(metadata) {
			const primReviewDate = metadata.wbmd_prim_revw_dt ? metadata.wbmd_prim_revw_dt : null;
			const secondReviewDate = metadata.wbmd_c_sec_med_revw_dt?  metadata.wbmd_c_sec_med_revw_dt : null;
			// Date(null) will result in Invalid date error so changed the date conditions above
			if (Date.parse(secondReviewDate)) {
				if (primReviewDate > secondReviewDate) {
					return primReviewDate;

				}
				return secondReviewDate;

			}
			return primReviewDate;
        },
        getReviewerDetails(metadata) {
			const reviewer = {};
			if (!metadata.wbmd_prim_med_revr) {
				return false;
			}
			const moduleObj = (metadata.wbmd_prim_med_revr || {});
			reviewer.name = this.getName(moduleObj);
			return reviewer;
        },
		getAuthorDetails(authorsData) {
			if (!authorsData) {
				return [];
			}
			let authorArray;
			const authors = [];

			if (_isArray(authorsData)) {
				authorArray = authorsData;
			} else if (_isObject(authorsData)) {
				authorArray = [];
				/* eslint-disable no-unused-vars */
				const obj = JSON.stringify(authorsData, (key, value) => {
					authorArray.push(value);
				});
				/* eslint-enable no-unused-vars */
			}
			if (authorArray) {
				authorArray.forEach((auth) => {
					const authorObject = {
						name: this.getName(auth).trim(),
						authorHrefName: auth.wbmd_bio_obj_id
							&& _has(auth, 'wbmd_bio_obj_id.link_friendlyurl')
							? auth.wbmd_bio_obj_id.link_friendlyurl : '',
					};
					if (authorObject && authorObject.name) {
						authors.push(authorObject);
					}
				});
			}
			return authors;
		},
        getPublisherLogo(metadata) {
			const publisherLogo = {};
			publisherLogo.src = metadata && _has(metadata, 'wbmd_cpyrt.wbmd_copyright_holder.wbmd_bus_logo.path')
				? metadata.wbmd_cpyrt.wbmd_copyright_holder.wbmd_bus_logo.path : '';
			publisherLogo.src = `${this.imageServerUrl}${publisherLogo.src}`;

			publisherLogo.alt = metadata && _has(metadata, 'wbmd_cpyrt.wbmd_copyright_holder.wbmd_bus_comp_nm')
				? metadata.wbmd_cpyrt.wbmd_copyright_holder.wbmd_bus_comp_nm : '';
			publisherLogo.alt = `Logo for ${publisherLogo.alt}`;

			return publisherLogo;
        },
        getName(moduleObj) {
			const firstName = (moduleObj.wbmd_first_nm ? moduleObj.wbmd_first_nm.trim() : '');
			const middleName = (moduleObj.wbmd_middle_name ? moduleObj.wbmd_middle_name.trim() : '');
			const lastName = (moduleObj.wbmd_lst_nm ? moduleObj.wbmd_lst_nm.trim() : '');
			let suffixGroup;
			let suffixList;
			let suffix;

			if (_has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix')
				&& _isArray(moduleObj.wbmd_person_suffix_group.wbmd_person_suffix)) {
				suffixGroup	= moduleObj.wbmd_person_suffix_group.wbmd_person_suffix.length > 0
					? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					: [];
			} else if (_has(moduleObj, 'wbmd_person_suffix_group.wbmd_person_suffix')
			&& _isObject(moduleObj.wbmd_person_suffix_group.wbmd_person_suffix)) {
				suffixGroup = moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					? moduleObj.wbmd_person_suffix_group.wbmd_person_suffix
					: [];
			}

			if (_isArray(suffixGroup)) {
				suffixList = suffixGroup.length > 0
					? suffixGroup.map(item => item.wbmd_disp_nm.trim())
					: [];
			} else if (_isObject(suffixGroup)) {
				suffixList	= suffixGroup ? suffixGroup.wbmd_disp_nm.trim()
					: [];
			} else {
				suffixList = [];
			}

			if (_isArray(suffixList)) {
				suffix = suffixList.length > 0
					? suffixList.join(', ')
					: [];
			} else if (suffixList) {
				suffix = suffixList ? suffixList : [];
			}

			return `${firstName}${middleName.length > 0 ? ` ${middleName}` : ''} ${lastName}${suffixList.length > 0 ? `, ${suffix}` : ''}`;
		},

		updateJsonldVideo(embededVdoModules) {
			if (!embededVdoModules) {
				return [];
			}
			this.jsonldVideo.name = embededVdoModules.embedVdoName[1] || '';
			this.jsonldVideo.description = embededVdoModules.embedVdoDescription[1] || '';
			this.jsonldVideo.uploadDate = embededVdoModules.embedVdoPubDate[1] || '';
			this.jsonldVideo.duration = embededVdoModules.embedVdoDuration || '';
			this.jsonldVideo.contentUrl = this.formatVideoSource(embededVdoModules.embedVdoContentUrl[1]) || '';
			this.jsonldVideo.thumbnailUrl = this.imageServerUrl + embededVdoModules.embedVdoThumbnail[1]
				|| `${this.imageServerUrl}/webmd/consumer_assets/site_images/logos/webmd/web/webmd_logo_gray.svg`;
			this.jsonldVideo.inLanguage = embededVdoModules.embedVdoinLanguage[1] || 'en';
			this.jsonldVideo.transcript = embededVdoModules.embedVdoTranscript || 'No transcript information is available for this video.';
			this.jsonldVideo.json = JSON.stringify(this.jsonldVideo).replace(/\\"/g, '\'');
		},

		formatVideoSource(videoSrc) {
			const sourceArr = [];
			const delimiter = '_,';

			if (videoSrc && videoSrc.includes(delimiter)) {
				// eslint-disable-next-line no-param-reassign
				videoSrc = `${videoSrc.split(delimiter)[0]}_1000k.mp4`;
			}
			sourceArr.push({
				src: `https://webmd-a.akamaihd.net/delivery${videoSrc}`,
				type: 'video/mp4',
			});
			return sourceArr[0].src;
		},

		updateJsonldData(metadata, imageObj) {
			if(!metadata){
				return [];
			}
			if(!imageObj) {
				delete this.jsonldData.primaryImageOfPage;
			}
			this.jsonldData.mainEntityOfPage = metadata.mainEntityOfPage;
			this.jsonldData.lastReviewed = metadata.lastReviewed;
			this.jsonldData.reviewedBy.name = metadata.reviewedBy.name;
			this.jsonldData.about = metadata.about;
			this.jsonldData.datePublished = metadata.datePublished;
			this.jsonldData.headline = metadata.headline;
			this.jsonldData.dateModified = (metadata.lastReviewed ? metadata.lastReviewed : metadata.datePublished);
			this.jsonldData.publisher.logo.url = metadata.publisherLogo.src;

			if(imageObj && !metadata.isnewsArticle) {
				this.jsonldData.primaryImageOfPage.name = imageObj.name || '';
				this.jsonldData.primaryImageOfPage.description = imageObj.description || '';
				this.jsonldData.primaryImageOfPage.url = this.imageServerUrl + imageObj.path || '';
				this.jsonldData.primaryImageOfPage.thumbnailUrl = this.imageServerUrl + imageObj.path || '';
				this.jsonldData.primaryImageOfPage.license = imageObj.credit || '';
			}

			if(metadata.isnewsArticle) {
				this.jsonldData['@type']= 'NewsArticle',
				this.jsonldData.description = metadata.desc;
				if (imageObj) {
					this.jsonldData.image = {};
					this.jsonldData.image['@type']= 'ImageObject',
					this.jsonldData.image.name = imageObj.name || '';
					this.jsonldData.image.description = imageObj.description || '';
					this.jsonldData.image.url = this.imageServerUrl + imageObj.path || '';
					this.jsonldData.image.thumbnailUrl = this.imageServerUrl + imageObj.path || '';
					this.jsonldData.image.license = imageObj.credit || '';
				} else {
					this.jsonldData.image = metadata.imagepath;
				}
				this.jsonldData.publisher.logo.url = `${this.imageServerUrl}/webmd/consumer_assets/site_images/logos/webmd/web/webmd_logo.svg`;
				this.jsonldData.publishingPrinciples = 'https://www.webmd.com/about-webmd-policies/about-editorial-policy';
				this.jsonldData.audience = 'https://schema.org/Clinician';
				delete this.jsonldData.primaryImageOfPage;
				delete this.jsonldData.lastReviewed;
				delete this.jsonldData.reviewedBy;
			}


			if(metadata.author && metadata.author.length){
				if(metadata.author.length > 1){
					delete this.jsonldData.author;
					metadata.author.forEach((author, index) => {
						const authorObj = {
							[`author${index+1}`]: {
								'@type': 'Person',
								name: author.name ? author.name : '',
							},
						};
						if (authorObj) {
							this.jsonldData = { ...this.jsonldData, ...authorObj };
						}
					});
				}
				else{
					this.jsonldData.author.name = metadata.author && metadata.author[0].name
						? metadata.author[0].name : '';
				}

			}
			this.jsonldData.json = JSON.stringify(this.jsonldData).replace(/\\"/g, '\'');
		},

		formatDate(date) {
			const dt = new Date(date);
			const monthNames = [
				'January', 'February', 'March',
				'April', 'May', 'June', 'July',
				'August', 'September', 'October',
				'November', 'December',
			];

			let day = dt.getDate();
			const monthIndex = dt.getMonth();
			const year = dt.getFullYear();

			day = (day > 9) ? day : (`0${day}`);
			this.formattedDate = monthNames[monthIndex] && day && year && `${monthNames[monthIndex]} ${day}, ${year}`;
			return this.formattedDate;

			
		},

		getImageServerUrl() {
			return this.store?.pagedata?.omniture?.image_server_url
		},
	},
    
};
